<template>
    <div id="costs">
        
        <v-app>
        
            <v-content>

                <v-container>

                    <v-stepper v-model="step">
                        <v-stepper-header class="stepper">
                            <v-stepper-step step="1" :complete="complete.prevention" @click="step = 1">Prevention</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2" :complete="complete.appraisal" @click="step = 2">Appraisal</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3" :complete="complete.internalFailure" @click="step = 3">Internal Failure</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="4" :complete="complete.externalFailure" @click="step = 4">External Failure</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="5" :complete="complete.other" @click="step = 5">Other</v-stepper-step>
                        </v-stepper-header>

                        <v-stepper-items>
                            
                            <Prevention 
                                :visible="visible"
                                :verified="verified"
                                :total="totalCosts.prevention"
                                @update-total="updateTotal"
                                @sections-complete="sectionsCompleted"
                            />
                            
                            <Appraisal 
                                :visible="visible"
                                :verified="verified"
                                :total="totalCosts.appraisal"
                                @previous-step="step--"
                                @update-total="updateTotal"
                                @sections-complete="sectionsCompleted"
                            />

                            <InternalFailure 
                                :visible="visible"
                                :verified="verified"
                                :total="totalCosts.internalFailure"
                                @previous-step="step--"
                                @update-total="updateTotal"
                                @sections-complete="sectionsCompleted"
                            />

                            <ExternalFailure 
                                :visible="visible"
                                :verified="verified"
                                :total="totalCosts.externalFailure"
                                @previous-step="step--"
                                @update-total="updateTotal"
                                @sections-complete="sectionsCompleted"
                            />

                             <Other 
                                :visible="visible"
                                :verified="verified"
                                :total="totalCosts.other"
                                @previous-step="step--"
                                @update-total="updateTotal"
                                @sections-complete="sectionsCompleted"
                            />

                        </v-stepper-items>

                    </v-stepper>         
                    
                </v-container>    
            
            </v-content>

        </v-app>

    </div>
</template>

<script>
    import Prevention from './CostSections/Prevention.vue';
    import Appraisal from './CostSections/Appraisal.vue';
    import InternalFailure from './CostSections/InternalFailure.vue';
    import ExternalFailure from './CostSections/ExternalFailure.vue';
    import Other from './CostSections/Other.vue';

    export default {
        name: 'costs',
        data: () => ({
            step: 1,
            errors: [],
            rules: {
                num: (value) => {
                    const pattern = /^\d+$/;
                    return pattern.test(value) || "Numbers Only"
                }
            },
            finalTotal: 0,
            totalCosts: {
                prevention: 0,
                appraisal: 0,
                internalFailure: 0,
                externalFailure: 0,
                other: 0
            },
            averageTotal: null,
            visible: {
                inspection: true,
                training: true,
                procedureDevelopment: true,
                priorToProcessing: true,
                testAndInspection: true,
                instrumentCalibration: true,
                fieldTesting: true,
                monitoringProcess: true,
                rework: true,
                scrap: true,
                checkingOutputs: true,
                lostCustomers: true,
                returns: true,
                recalls: true,
                fieldServices: true,
                afterDelivery: true,
                defectsRework: true,
                overproduction: true,
                waiting: true,
                nonUtilizedTalentsSkills: true,
                transportation: true,
                inventory: true,
                motion: true,
                extraProcessing: true
            },
            verified: {
                inspection: '',
                training: '',
                procedureDevelopment: '',
                priortoProcessing: "",
                testAndInspection: "",
                instrumentCalibration: "",
                fieldTesting: "",
                monitoringProcess: "",
                rework: "",
                scrap: "",
                checkingOutputs: "",
                lostCustomers: "",
                returns: "",
                recalls: "",
                fieldServices: "",
                afterDelivery: "",
                defectsRework: "",
                overproduction: "",
                waiting: "",
                nonUtilizedTalentsSkills: "",
                transportation: "",
                inventory: "",
                motion: "",
                extraProcessing: ""
            },
            complete: {
                prevention: false,
                appraisal: false,
                internalFailure: false,
                externalFailure: false,
                other: false
            }
        }),
        components: {
            Prevention,
            Appraisal,
            InternalFailure,
            ExternalFailure,
            Other
        },
        methods:{
            updateTotal([costTotal, costTitle]) {
                this.totalCosts[costTitle] = costTotal;
            },
            sectionsCompleted([costs, section]) {
                for (let key in costs) {
                    let valueExists = false;

                    if(costs[key].constructor === Array) {
                        costs[key].forEach(cost => {
                            if(cost.value !== null && isNaN(cost.value)) {
                                valueExists = true;
                                return;
                            }
                        })
                        if (valueExists) {
                            this.verified[`${key}`] = 'success';
                            this.visible[`${key}`] = false;
                        } 
                    }
                    
                }

                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                this.complete[section] = true;
                this.step++;

            },
            calculateTotals() {
                const costs = Object.keys(this.totalCosts)
                costs.forEach(cost => {
                    this.finalTotal += this.totalCosts[cost];
                })
                this.averageTotal = this.finalTotal / 5;
                this.$emit('render-cost-average', (this.finalTotal / 5));
                this.$emit('render-cost-totals', this.totalCosts);
                this.$emit('render-final-total', this.finalTotal);
            }
        },
        created: function() {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        watch: {
            step: function() {
                if (this.step === 6) {
                    this.calculateTotals();
                }
            }
        }
    }

</script>

<style>
.subcost {
    width: 100% !important;
}
.cell {
    padding: 0.5rem;
}
.v-stepper__step {
    cursor: pointer;
}

.v-jumbotron {
    height: 5rem !important;
    margin-bottom: 1rem !important;
}

</style>